import {useEffect} from 'react';

import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {usePlaybook} from '../hooks/usePlaybook.ts';
import {usePlaybooksSelection} from '../hooks/usePlaybooksSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {IndexPage as PhasesPage} from "../../phases/pages/IndexPage.tsx";

export const EditPage = () => {

    const {id: playbookId} = useParams();

    if (typeof playbookId === 'undefined') {
        throw new Error('playbookId is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`/playbooks/${playbookId}`);
    }

    const {
        record: playbook,
        updateRecord,
    } = usePlaybook(playbookId);

    const {handleClearSelection} = usePlaybooksSelection();

    const {
        mode,
        tools,
    } = useEditPageTools(playbook);


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (!playbook) {
        return <PlatformLoader message='Loading playbook...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={playbook.name ? playbook.name : playbook.id}
            pageNavigation={<EditPageNavigation component={playbook}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 3
                    }}>
                        <Profile record={playbook}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 9
                    }}>
                        <SimplePageContentWrapper>
                            <PhasesPage/>
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={playbook}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />}


        </FormPageLayout>
    );
};
